<div class="details-page" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="5px" style="margin: 20px 50px;">
    <div class="details-container" fxLayout="column" fxLayoutAlign="start stretch"
        style="background-color: white; width: 86%; padding: 10px; border: 1px solid #ddd; border-radius: 5px;">
        <div fxLayout="row" style="margin-bottom: 10px;">
            <div style="font-size: 24px; font-weight: bold;">{{spec["Price Breakup"]}}</div>
            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" style="margin-left:20px;">
                <div style="font-size: 14px; color: #888;">EMI - ₹{{property.emi}}</div>
                <div style="font-size: 14px; color: #888;">|</div>
                <div style="font-size: 14px; color: #888; text-decoration: underline; cursor: pointer;">Get pre-approved
                    loan
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="start start" style="margin-bottom: 20px;">
            <div style="font-size: 16px;">{{product.description}}</div>
        </div>
        <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="2px" style="margin-bottom: 20px">
            <div fxHide fxShow.gt-sm  class="product-details padding-15" style="margin-right: 15px; flex: 1 1 100%;box-sizing: border-box;max-width: 50%;">
                <calsoft-product-image [name]="name" [configProductSelected]="configProductSelected" [product]="product"
                    [imageList]="imageList" [image]="image" [productDetailHeight]="productDetailHeight"
                    [productDetailWidthMobile]="productDetailWidthMobile"
                    [productDetailHeightMobile]="productDetailHeightMobile"
                    [productIdAddedInCart]="productIdAddedInCart" [data]="data" [zoomImage]="zoomImage"
                    (mouseMoveEvent)="onMouseMove($event)" (leaveMoveEvent)="onMouseLeave($event)"
                    [productDetailImageWidth]="productDetailImageWidth" [productzoom]="productzoom"
                    [imageList]="imageList" [ColdChain]="ColdChain" (zoomImageEvent)="setZoomImage($event)"
                    [displayColdChain]="displayColdChain"></calsoft-product-image>
            </div>
            <div fxLayout="column" fxLayoutGap="30px" class="logo-no">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px"
                    style="background-color: #f5f5f5;padding: 15px;border-radius: 9px;">
                    <div fxLayout="column" fxLayoutAlign="center center" fxFlex="auto">
                        <div style="display: flex; align-items: center;"><img src="bed-icon.png" alt="Beds"
                                style="width: 24px; margin-right: 5px;">{{property.beds}} Beds</div>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="center center" fxFlex="auto">
                        <div style="display: flex; align-items: center;"><img src="bath-icon.png" alt="Baths"
                                style="width: 24px; margin-right: 5px;">{{property.baths}} Baths</div>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="center center" fxFlex="auto">
                        <div style="display: flex; align-items: center;"><img src="balcony-icon.png" alt="Balcony"
                                style="width: 24px; margin-right: 5px;">{{property.balconies}} Balcony</div>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="center center" fxFlex="auto">
                        <div style="display: flex; align-items: center;"><img src="furnished-icon.png" alt="Furnished"
                                style="width: 24px; margin-right: 5px;">{{spec.Furnishing}}</div>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="94px" class="rows-values"
                    *ngFor="let row of property.rows">
                    <div fxFlex="auto" *ngFor="let item of row">
                        <div>{{item.key}}</div>
                        <div style="font-weight: bold;">{{item.value}}</div>
                        <div *ngIf="item.subvalue" style="color: #888;">{{item.subvalue}}</div>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="94px">
                    <div fxFlex="auto">
                        <div>Status</div>
                        <div style="font-weight: bold;">{{property.status}}</div>
                    </div>
                    <div fxFlex="auto">
                        <div>Facing</div>
                        <div style="font-weight: bold;">{{property.facing}}</div>
                    </div>
                    <div fxFlex="auto" style="margin-left: 10px;">
                        <div>Furnished Status</div>
                        <div style="font-weight: bold;">Semi-Furnished</div>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="94px">
                    <div fxFlex="auto">
                        <div>Type Of Ownership</div>
                        <div style="font-weight: bold;">{{property.ownershipType}}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <hr style="margin: 10px 0;"> -->
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <button mat-raised-button (click)="generateWhatsAppMessage()" class="primary block" style="color:white;">
                <img style="height: 24px; color: white;" [alt]="'Enquire About'" src="assets/icons/whatsapp.svg">
                Contact Owner
            </button>
            <!-- <button (mouseover)="toggleButtonColor($event, true)" (mouseout)="toggleButtonColor($event, false)"
                style="background-color: #dc3545; color: white; padding: 10px 20px; border: none; border-radius: 5px; cursor: pointer;">
                Get Phone No.
            </button> -->
            <button mat-raised-button (click)="generateWhatsAppMessage()" class="primary block" style="color:white;">
                <img style="height: 24px; color: white;" [alt]="'Enquire About'" src="assets/icons/whatsapp.svg">
                Get Phone no
            </button>
            <div style="color: #888;">Last contact made {{property.lastContact}}</div>
        </div>
    </div>
</div>

<div fxLayout="column" fxLayoutAlign="start start"
    style="border: 1px solid #ddd; padding: 20px; border-radius: 10px; background-color: #fff; margin: 20px 50px; width: 75%;">
    <div style="font-size: 24px; font-weight: bold; margin-bottom: 20px;">More Details</div>
    <div fxLayout="column" fxLayoutGap="15px">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" *ngFor="let item of spec | keyvalue">
            <div style="font-size: 16px; font-weight: bold;" fxFlex="20%">{{item.key.replace('_', ' ') }}</div>
            <div fxFlex="50%" style="font-size: 16px;">{{item.value}}
            </div>
        </div>
        <!-- <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
        <div style="font-size: 16px; font-weight: bold;" fxFlex="20%">Address</div>
        <div fxFlex="50%" style="font-size: 16px;">{{property.address}}</div>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
        <div style="font-size: 16px; font-weight: bold;" fxFlex="20%">Landmarks</div>
        <div fxFlex="50%" style="font-size: 16px;">{{property.landmarks}}</div>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
        <div style="font-size: 16px; font-weight: bold;" fxFlex="20%">Furnishing</div>
        <div fxFlex="50%" style="font-size: 16px;">{{property.furnishing}}</div>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
        <div style="font-size: 16px; font-weight: bold;" fxFlex="20%">Type of Ownership</div>
        <div fxFlex="50%" style="font-size: 16px;">{{property.ownershipType}}</div>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
        <div style="font-size: 16px; font-weight: bold;" fxFlex="20%">Description</div>
        <div fxFlex="50%" style="font-size: 16px;">{{property.description}}</div>
      </div> -->
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" style="margin-top: 20px;">
        <!-- <button (mouseover)="toggleButtonColor($event, true)" (mouseout)="toggleButtonColor($event, false)"
        style="background-color: #dc3545; color: white; padding: 10px 20px; border: none; border-radius: 5px; cursor: pointer;">
        Contact Owner
      </button> -->
        <button mat-raised-button (click)="generateWhatsAppMessage()" class="primary block" style="color:white;">
            <img style="height: 24px; color: white;" [alt]="'Enquire About'" src="assets/icons/whatsapp.svg">
            Contact Owner
        </button>
    </div>
</div>

<div fxLayout="column" fxLayoutAlign="start start" 
    style="border: 1px solid #ddd; padding: 20px; border-radius: 10px; background-color: #fff; margin: 20px 50px; width: 75%;">
    
    <div style="font-size: 28px; font-weight: bold; margin-bottom: 20px;">About {{city.name}}</div>
    
    <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-bottom: 20px;">
        <div fxLayout="column" fxLayoutAlign="center center">
            <div style="font-size: 20px; font-weight: bold;">{{city.rating}}</div>
            <div style="color: #f39c12; font-size: 20px;">★★★★★</div>
            <div style="font-size: 16px; color: #888;">{{city.reviews}} Reviews</div>
        </div>
        <div style="text-align: right;">
            <div style="font-size: 20px; font-weight: bold;">Rank {{city.rank}}</div>
            <div style="font-size: 16px; color: #888;">out of 5196 localities</div>
        </div>
    </div>
    
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px" style="margin-bottom: 20px;">
        <div fxFlex="30%">
            <div style="font-size: 16px;">Environment</div>
            <div style="font-size: 16px; font-weight: bold;">{{city.attributes.environment}}</div>
        </div>
        <div fxFlex="30%">
            <div style="font-size: 16px;">Commuting</div>
            <div style="font-size: 16px; font-weight: bold;">{{city.attributes.commuting}}</div>
        </div>
        <div fxFlex="30%">
            <div style="font-size: 16px;">Places of Interest</div>
            <div style="font-size: 16px; font-weight: bold;">{{city.attributes.placesOfInterest}}</div>
        </div>
    </div>
    
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" class="cards-container" 
        style="overflow: hidden; position: relative; margin-bottom: 20px; width: 100%;">
        <button *ngIf="currentIndex > 0" mat-icon-button (click)="slideLeft()" style="background: none; border: none; cursor: pointer;">
            <mat-icon>chevron_left</mat-icon>
        </button>
        <div fxLayout="row" fxLayoutGap="10px" class="cards-slider" 
            style="transition: transform 0.5s; width: 100%; transform: translateX({{transform}});">
            <div *ngFor="let card of city.cards" 
                style="flex: 0 0 33.33%; padding: 10px; border: 1px solid #ddd; border-radius: 10px; background-color: #f9f9f9;">
                <div style="font-size: 18px; font-weight: bold;">{{ card.title }}</div>
                <div *ngFor="let item of card.items" style="font-size: 16px;">{{ item }}</div>
            </div>
        </div>
        <button *ngIf="currentIndex < city.cards.length - visibleCards" mat-icon-button (click)="slideRight()" style="background: none; border: none; cursor: pointer;">
            <mat-icon>chevron_right</mat-icon>
        </button>
    </div>
    
    <div style="text-align: right; margin-top: 10px;">
        <button style="background-color: #dc3545; color: white; padding: 10px 20px; border: none; border-radius: 5px;">Explore Locality</button>
    </div>
    
    <div style="margin-top: 20px; font-size: 16px;">
        <span>{{ city.description }}</span>
        <span *ngIf="showMore">{{ city.moreText }}</span>
        <span (click)="toggleShowMore()" style="color: #007bff; cursor: pointer;">{{ showMore ? 'Show less' : 'Show more' }}</span>
    </div>
    
    <div style="text-align: center; margin-top: 20px;">
        <button style="background-color: #6c757d; color: white; padding: 10px 20px; border: none; border-radius: 5px;">Compare Localities</button>
    </div>
</div>



